let arGTM = {
    'bioritmo' : 'GTM-MKHPPB',
    'br' : 'GTM-T67M7MR',
    'ar' : 'GTM-NSF2MNS',
    'cl' : 'GTM-T4LG9H',
    'co' : 'GTM-MRV43RH',
    'ec' : 'GTM-MQJL74T',
    'gt' : 'GTM-P4W27FM',
    'mx' : 'GTM-NBG82P',
    'pa' : 'GTM-WMR3S9Q',
    'py' : 'GTM-5GJHW3H',
    'pe' : 'GTM-W6HZMW9',
    'do' : 'GTM-NQ74D2B',
    'sv' : 'GTM-5JS9LFJ',
}


let { host } = window.location;
let host_parts = host.split('.');

export const fallback_theme = host.replace('www.','').replace('treineemcasa.','').replace('entrenaencasa.','').split('.')[0]
export const fallback_locale = host.indexOf('.br') == -1 ? 'ar' : 'br'
export const fallback_country = host.indexOf('smartfit') > -1 ? host_parts[host_parts.length - 1]: 'bioritmo'
export const fallback_gtm = arGTM[host.indexOf('smartfit') > -1 ? host_parts[host_parts.length - 1]: 'bioritmo']
